import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-277ea1ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "docs" }

import {
    nextTick,
    onMounted,
    reactive,
    ref,
    UnwrapRef,
} from "vue";
import {
    addMedicalProduct,
    deleteMedicalProduct, getById,
    pageListMedicalProduct,
    updateMedicalProduct
} from "@/api/medicalProduct";
import {message} from "ant-design-vue";
import UploadImagePreview from "@/components/view/UploadImagePreview.vue";
import {ValidateErrorEntity} from "ant-design-vue/es/form/interface";
import {getTreatTypes} from "@/api/sale_order";
interface Data{
    labelCol: any,
    wrapperCol: any,
    dataSource: any[],
    columns: any[],
    loading: boolean,
    formVisible: boolean,
    title: string,
    rules: any,
    options: any[],
    pagination: any,
}
interface FormState {
    keyword: string;
    page: any,
}
interface AddOrUpdateForm {
    id: string;
    name: string;
    productDescribe: string;
    specification: any[];
    docs: any[];
    treatIds: any[];
    owner: string;
    switchMonitor: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let docsValidator = () => {
    let flag = false;
    addOrUpdateForm.docs.forEach((item) => {
        if (item.path) {
            flag = true;
        }
    });
    if (flag) {
        return Promise.resolve();
    } else {
        return Promise.reject("请上传至少一张产品图片!");
    }
};
const data: UnwrapRef<Data> = reactive({
    pagination: {
        size: "small",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: false,
        showSizeChanger: true,
    },
    labelCol: { style: { width: '80px' } },
    wrapperCol: { span: 20 },
    dataSource: [],
    options: [],
    loading: false,
    formVisible: false,
    title: "新增医疗产品",
    rules: {
        name:[
            {
                required: true,
                trigger: "change",
            }
        ],
        docs: [
            { validator: docsValidator, trigger: "change",required: true },
        ],
        specification: [
            { trigger: "change",required: true },
        ],
        treatIds: [
            { required: true, trigger: "change" },
        ],
    },
    columns: [
        {
            title: "序号",
            dataIndex: "key",
            key: "key",
            width: 40,
            customRender: ({ index }: any) => `${index + 1}`,
        },
        {
            title: "名称",
            dataIndex: "name",
            key: "name",
            width: 40,
        },
        {
            title: "产品规格",
            dataIndex: "specification",
            key: "specification",
            width: 120,
        },
        {
            title: "描述",
            dataIndex: "productDescribe",
            key: "productDescribe",
            width: 40,
        },
        {
            title: "绑定治疗项",
            dataIndex: "treats",
            key: "treats",
            width: 40,
            customRender: ({ record }: any) => `${record.treats.map((e: any)=>{return e.treatName}).join(",")}`,
        },
        {
            title: "操作",
            dataIndex: "operation",
            key: "operation",
            width: 40,
        },
    ]
})
const formState: UnwrapRef<FormState> = reactive({
    keyword: '',
    page: {
        currPage: 1,
        pageSize: 10,
    },
});
const addOrUpdateForm: UnwrapRef<AddOrUpdateForm> = reactive({
    id: '',
    name: '',
    productDescribe: '',
    specification: [],
    docs: [
        {
            title: "产品图片一",
            path: "",
            type: "MEDICAL_PRODUCT_1",
            id: ''
        },
        {
            title: "产品图片二",
            path: "",
            type: "MEDICAL_PRODUCT_2",
            id: ''
        },
        {
            title: "产品图片三",
            path: "",
            type: "MEDICAL_PRODUCT_3",
            id: ''
        },
    ],
    treatIds:[],
    owner:'',
    switchMonitor: false,
});
const onSubmit = () => {
    data.pagination.current = 1
    list();
};
const createMedicalProductRef = ref();
const add = ()=>{
    addMedicalProduct(addOrUpdateForm).then(()=>{
        message.success("新增成功");
        data.formVisible = false;
        list();
    }).catch(()=>{
        message.warning("操作失败")
    })
}
const update = ()=>{
    updateMedicalProduct(addOrUpdateForm).then(()=>{
        message.success("修改成功");
        data.formVisible = false;
        list();
    }).catch(()=>{
        message.warning("操作失败")
    })
}
const deleteData = (id: string)=>{
    deleteMedicalProduct(id).then(()=>{
        message.success("操作成功");
        list()
    })
}
const resetForm = ()=>{
    createMedicalProductRef.value?.resetFields();
    addOrUpdateForm.docs = [
        {
            title: "产品图片一",
            path: "",
            type: "MEDICAL_PRODUCT_1",
            id: ''
        },
        {
            title: "产品图片二",
            path: "",
            type: "MEDICAL_PRODUCT_2",
            id: ''
        },
        {
            title: "产品图片三",
            path: "",
            type: "MEDICAL_PRODUCT_3",
            id: ''
        },
    ]
}
const onAdd = ()=>{
    data.title = '新增医疗产品';
    addOrUpdateForm.id = ''
    data.formVisible=true;
    resetForm();
}
const onUpdate = (record: any)=>{
    resetForm();
    getById(record.id).then((res:any)=>{
        data.title = '修改医疗产品';
        data.formVisible=true;
        nextTick(()=>{
            addOrUpdateForm.id = record.id;
            addOrUpdateForm.name = res.name;
            addOrUpdateForm.owner = res.owner;
            addOrUpdateForm.productDescribe = res.productDescribe;
            addOrUpdateForm.specification = res.specification;
            addOrUpdateForm.switchMonitor = res.switchMonitor;
            addOrUpdateForm.treatIds = res.treats.map((e:any)=>{return e.id});
            addOrUpdateForm.docs.forEach((e:any)=>{
                let tdocs = res.docs.filter((x: any)=>{return x.type === e.type});
                if(tdocs && tdocs.length>0 && tdocs[0].path){
                    e.id = tdocs[0].id;
                    e.path = tdocs[0].path;
                    e.type = tdocs[0].type
                }
            });
        })
    })
}

const onAddOrUpdate = ()=>{
    createMedicalProductRef.value.validate().then(() => {
        if(addOrUpdateForm.id){
            update();
        }else{
            add();
        }
    })
        .catch((error: ValidateErrorEntity<FormState>) => {
            console.log('error', error);
        });
}

const onCancel = ()=>{
    resetForm()
}

// 上传成功回调
const onSuccess = (url: string, type: number) => {
    console.log(url, type);
    addOrUpdateForm.docs[type].path = url;
    createMedicalProductRef.value.validate("docs")
};
const onRemove = (type: number) => {
    console.log(type);
    addOrUpdateForm.docs[type].path = '';
    createMedicalProductRef.value.validate("docs")
}
const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    list();
};
const list = ()=>{
    data.loading = true;
    formState.page.pageSize = data.pagination.pageSize;
    formState.page.currPage = data.pagination.current;
    pageListMedicalProduct(formState).then((res: any)=>{
        data.dataSource = (res && res.data)?res.data:[];
        data.pagination.total = res.records;
        data.loading = false;
    }).catch(()=>{
        data.loading = false;
    })
}
const onSearchTreats = ()=>{
    getTreatTypes('0').then((res: any[])=>{
        //只能绑定正畸的产品
        // data.options = res.filter((e:any)=>{
        //     return e.label.indexOf('正畸')> -1;
        // })
        data.options = res
    })
}
onMounted(()=>{
    list();
    onSearchTreats();
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: formState,
          "label-col": data.labelCol,
          "wrapper-col": data.wrapperCol,
          layout: "inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "关键字" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formState.keyword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.keyword) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "wrapper-col": { span: 10, offset: 4 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "wrapper-col": { span: 10, offset: 4 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: onAdd
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "label-col", "wrapper-col"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, { style: {"margin-top":"20px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: data.dataSource,
          columns: data.columns,
          loading: data.loading,
          pagination: data.pagination,
          onChange: changePageIndex
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.dataIndex === 'specification')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(record.specification, (item) => {
                  return (_openBlock(), _createBlock(_component_a_tag, {
                    color: "green",
                    key: item
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              : _createCommentVNode("", true),
            (column.dataIndex === 'operation')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (onUpdate(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("修改")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "确定删除该医疗产品?",
                    "ok-text": "是",
                    "cancel-text": "否",
                    onConfirm: ($event: any) => (deleteData(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: data.formVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((data.formVisible) = $event)),
      title: data.title,
      width: "40%",
      onClose: onCancel,
      onOk: onAddOrUpdate
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: addOrUpdateForm,
          "label-col": data.labelCol,
          "wrapper-col": data.wrapperCol,
          autoComplete: "off",
          rules: data.rules,
          ref_key: "createMedicalProductRef",
          ref: createMedicalProductRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "产品名称",
                      name: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: addOrUpdateForm.name,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((addOrUpdateForm.name) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "产品图片",
              name: "docs"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addOrUpdateForm.docs, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createVNode(UploadImagePreview, {
                        path: item.path,
                        fileUrl: '/avatar',
                        onOnSuccess: (url) => onSuccess(url, index),
                        onOnRemove: ($event: any) => (onRemove(index))
                      }, null, 8, ["path", "onOnSuccess", "onOnRemove"]),
                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "产品规格",
                      name: "specification"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: addOrUpdateForm.specification,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addOrUpdateForm.specification) = $event)),
                          mode: "tags",
                          style: {"width":"100%"},
                          "token-separators": [','],
                          placeholder: "以英文逗号隔开,",
                          options: []
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "描述",
                      name: "productDescribe"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: addOrUpdateForm.productDescribe,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addOrUpdateForm.productDescribe) = $event)),
                          placeholder: "请输入描述",
                          rows: 4
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "关联治疗项",
                      name: "treatIds"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: addOrUpdateForm.treatIds,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((addOrUpdateForm.treatIds) = $event)),
                          mode: "multiple",
                          "allow-clear": ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.options, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                disabled: addOrUpdateForm.treatIds.length>=1,
                                key: item.value,
                                value: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["disabled", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "开启监护",
                      name: "switchMonitor"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_switch, {
                          checked: addOrUpdateForm.switchMonitor,
                          "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((addOrUpdateForm.switchMonitor) = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "label-col", "wrapper-col", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})